import React, { useState, useEffect } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import { ExpandedComponent } from "../Super-admin/ExpandedComponent";
import { Footer } from "../../Footer";
import { Button, Col, Row } from "react-bootstrap";
import {
  GetAnnouncementGetAllAuction,
  AnnouncementData,
  GetAnnouncementGetAllAuctionData,
} from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import * as icons from "react-bootstrap-icons";

export const PlayerAnnouncment = () => {
  const [data, setData] = useState();
  const [searchText, setSearchText] = useState("");
  const [announcements, setAnnouncements] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const pageOptions = [10, 20, 30, 50];
  function sidebarfun() {
    setData(!data);
  }
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: <strong>Auction Name</strong>,
      selector: (row) => row?.auctionName,
      sortable: true,
    },
    {
      name: <strong>Contest Name</strong>,
      selector: (row) => row?.tournamentName,
      sortable: true,
    },

    {
      name: <strong>Sport Name</strong>,
      selector: (row) => row?.sportName,
      sortable: true,
    },
    {
      name: <strong>Total Pool</strong>,
      selector: (row) => row?.totalPoolAmount,
      sortable: true,
    },
    {
      name: <strong> Manager Hold</strong>,
      selector: (row) => row?.xcuttaAmount,
      sortable: true,
    },
    {
      name: <strong>Net Pool</strong>,
      selector: (row) => row?.netPoolAmount,
      sortable: true,
    },

    {
      name: <strong>Auction Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },

      sortable: true,
      sortFunction: (a, b) => {
        // Compare the endDate values directly
        const dateA = dayjs(a.startDate).valueOf(); // Convert to timestamp for comparison
        const dateB = dayjs(b.startDate).valueOf(); // Convert to timestamp for comparison
        return dateA - dateB; // Return the difference for sorting
      },
      width: "250px",
    },

    {
      name: <strong>Auction End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },

      sortable: true,
      sortFunction: (a, b) => {
        // Compare the endDate values directly
        const dateA = dayjs(a.endDate).valueOf(); // Convert to timestamp for comparison
        const dateB = dayjs(b.endDate).valueOf(); // Convert to timestamp for comparison
        return dateA - dateB; // Return the difference for sorting
      },
      width: "250px",
    },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const filteredData = searchText
    ? announcements.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.managerName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.sportName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : announcements;

  // useEffect(() => {
  //   const AnnouncementMsgFunc = async () => {
  //     await GetAnnouncementGetAllAuction().then((response) => {

  //       const sortedData = response?.data?.sort((a, b) => new Date(b.date) - new Date(a.date));
  //       sortedData?.reverse();
  //       setAnnouncements([...sortedData]);
  //     });
  //   };
  //   AnnouncementMsgFunc();
  // }, []);

  const AnnouncementMsgFunc = async (data) => {
    try {
      const response = await GetAnnouncementGetAllAuctionData(data); // Call your API function
      if (response?.data) {
        const sortedData = response?.data?.data?.dataList.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        setAnnouncements([...sortedData] || []);
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    AnnouncementMsgFunc(data); // Fetch data when currentPage changes
  }, [currentPage]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    AnnouncementMsgFunc(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  useEffect(() => {
    const AnnouncementDataFunc = async () => {
      await GetAnnouncementGetAllAuction().then((response) => {});
    };
    AnnouncementDataFunc();
  }, []);
  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Auction Rusults</h1>
            </Col>
          </Row>

          <div className="group_data_table player-anouncement">
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            {/* <DataTable
              title="Announcement"
              columns={columns}
              data={filteredData}
              pagination
              expandableRows
              expandableRowExpanded={(row) => row.defaultExpanded}
             
              expandableRowsComponent={({ data }) => (
                <ExpandedComponent data={data} />
              )}
              expandableRowsComponentProps={{ additionalProp: (row) => row?.auctionName }}
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 30]}
              paginationTotalRows={filteredData?.length}
            /> */}

            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                expandableRows
                expandableRowExpanded={(row) => row.defaultExpanded}
                expandableRowsComponent={({ data }) => (
                  <ExpandedComponent data={data} />
                )}
                expandableRowsComponentProps={{
                  additionalProp: (row) => row.auctionName,
                }}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
